import * as React from "react";

export default function CategoriesSearch({
	isCategory,
	setIsCategory,
	setPage,
}) {
	return (
		<div className="row d-flex justify-content-end">
			<div className="col-lg-3 col-md-4 col-sm-12 d-flex justify-content-end">
				<input
					id="standard-basic"
					className="p-2 w-100 admin-search-category"
					placeholder="Search Category"
					value={isCategory}
					onChange={(e) => {
						setPage(0);
						setIsCategory(e.target.value);
					}}
				/>
			</div>
		</div>
	);
}
